/* Chef Hassan's Kitchen: one menu category at a time.
   The catering menu's sub-category bar works like tabs: picking a category shows only its dishes.
   Every category is already in the page (so search engines and no-JavaScript visitors see all of them);
   this just decides which one is on screen. A small inline script in the section picks the starting
   category before first paint; this file handles the taps. */
(function () {
  'use strict';
  var groups = Array.prototype.slice.call(document.querySelectorAll('.Collection-body .Collection-group'));
  var bar = document.querySelector('.Collection-jump');
  if (groups.length < 2 || !bar) return;
  var links = Array.prototype.slice.call(bar.querySelectorAll('a[href^="#"]'));

  function show(id, fromUser) {
    var target = null;
    groups.forEach(function (g) {
      if (g.id === id) target = g;
    });
    if (!target) target = groups[0];
    groups.forEach(function (g) {
      if (g === target) g.setAttribute('data-active', ''); else g.removeAttribute('data-active');
    });
    links.forEach(function (a) {
      if (a.getAttribute('href') === '#' + target.id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    // Keep the pill that was picked in view, and bring the dishes to the top if we're scrolled past them.
    var on = bar.querySelector('[aria-current="true"]');
    if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest', inline: 'center' });
    if (fromUser) {
      var top = document.querySelector('.Collection-body').getBoundingClientRect().top + window.scrollY - bar.offsetHeight - 8;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  bar.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    e.preventDefault();
    var id = a.getAttribute('href').slice(1);
    show(id, true);
    if (history.pushState) history.pushState(null, '', '#' + id); else location.hash = id;
  });
  window.addEventListener('hashchange', function () { show(location.hash.slice(1), false); });
  show(location.hash.slice(1), false);
})();
